import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { ContratoService } from '../../../../providers/contrato-service';

@Component({
  selector: 'page-modal-pv-contratos',
  templateUrl: 'modal-pv-contratos.html'
})
export class ModalPreVisualizarContratosPage {
  titulo: any;
  isJurisdicionado: any;
  listaDados: any[];
  dataGeracao: any;
  loading: boolean = true;
  shownGroup: any;
  limiteDiferencaLimiteLegal: any = 25.00;

  constructor(private viewCtrl: ViewController,
    public navParams: NavParams,
    public contratosService: ContratoService,
    public alertCtrl: AlertController,
    public gestaoPcaService: GestaoPcaService) {

    this.dataGeracao = new Date();

    this.listarDados();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  listarDados() {
    this.contratosService.obterContratosCertificado().subscribe(
      data => {
        this.listaDados = data;
        this.loading = false;
      }, error => {
        this.listaDados = [];
        this.loading = false;
      }
    );
  }

  somarValorDosAcrescimos(contrato) {
    let total: any = 0;

    contrato.aditivos.forEach(aditivo => {
      // let listaProdutosAditivo = this.obterProdutosDoAditivo(aditivo.idAditivo);

      // if (listaProdutosAditivo != null) {
      //   contrato.listaProdutosAditivo.forEach(produto => {
      //     if (produto.tipo == 'Acréscimo') {
      total += aditivo.totalAcrescimo
      //     }
      //   });
      // }
    });

    //let porcentagemAcrescimoSobreContrato = (total / contrato.valorAtual) * 100;

    return this.formatarValorNumerico(total);
  }

  somarValorDasSupressoes(contrato) {
    let total: any = 0;

    contrato.aditivos.forEach(aditivo => {
      // let listaProdutosAditivo = this.obterProdutosDoAditivo(aditivo.idAditivo);

      // if (listaProdutosAditivo != null) {
      //   contrato.listaProdutosAditivo.forEach(produto => {
      //     if (produto.tipo == 'Supressão') {
      total += aditivo.totalSupressao
      //     }
      //   //   });
      //   // }
    });

    //let porcentagemAcrescimoSobreContrato = (total / contrato.valorAtual) * 100;

    return this.formatarValorNumerico(total);
  }

  calcularDiferencaAcrescimos(contrato) {
    let total: any = 0;

    contrato.aditivos.forEach(aditivo => {
      // let listaProdutosAditivo = this.obterProdutosDoAditivo(aditivo.idAditivo);

      // if (listaProdutosAditivo != null) {
      //   contrato.listaProdutosAditivo.forEach(produto => {
      // if (aditivo.tipo == 'Acréscimo') {
      total += aditivo.totalAcrescimo
      // }
      //   });
      // }
    });

    let porcentagemAcrescimoSobreContrato = (total / contrato.valorAtual) * 100;
    let diferencaLimiteAcrescimo = porcentagemAcrescimoSobreContrato - this.limiteDiferencaLimiteLegal;

    return this.formatarPorcentagem(diferencaLimiteAcrescimo);
  }

  calcularDiferencaSupressoes(contrato) {
    let total: any = 0;

    contrato.aditivos.forEach(aditivo => {
      // let listaProdutosAditivo = this.obterProdutosDoAditivo(aditivo.idAditivo);

      // if (listaProdutosAditivo != null) {
      // contrato.listaProdutosAditivo.forEach(produto => {
      // if (aditivo.tipo == 'Supressão') {
      total += aditivo.totalSupressao;
      // }
      // });
      // }
    });

    let porcentagemAcrescimoSobreContrato = (total / contrato.valorAtual) * 100;
    let diferencaLimiteAcrescimo = porcentagemAcrescimoSobreContrato - this.limiteDiferencaLimiteLegal;

    return this.formatarPorcentagem(diferencaLimiteAcrescimo);
  }

  formatarPorcentagem(valor) {
    let valorString = valor.toString();

    if (valorString.indexOf('.') != -1) {
      let tamanhoAntesDaVirgulas = valorString.indexOf('.') + 1;
      let numeroDeCasasDecimais = 2;
      valorString = valorString.substr(0, tamanhoAntesDaVirgulas + numeroDeCasasDecimais);
    }

    return valorString.replace('.', ',') + "%";
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  }
  isGroupShown(group) {
    return this.shownGroup === group;
  };

  calcularDiferencaDatas(aditivo) {
    let diferenca = 0;
    let assinatura;
    let vigencia;

    if (aditivo.assinatura) {
      assinatura = new Date(aditivo.assinatura.split("/").reverse().map(Number));
    }

    if (aditivo.novaDataVigencia) {
      vigencia = new Date(aditivo.novaDataVigencia.split("/").reverse().map(Number));
    }

    if (aditivo.assinatura && aditivo.novaDataVigencia) {
      var diff = Math.abs(vigencia.getTime() - assinatura.getTime());
      diferenca = Math.ceil(diff / (1000 * 3600 * 24));
    }

    return diferenca;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/contratos/modal-pv-contratos.ts